export const config = {
  title: "Texas V.J. Construction",
  meta: {
    description:
      "Texas V.J. Construction provides expert home renovation, additions, remodeling, carpentry, concrete, and general contracting services in Wilmington, DE.",
    keywords: [
      "Wilmington home renovation",
      "Texas VJ Construction",
      "DE remodeling contractor",
      "house additions Wilmington",
      "general contractor Delaware"
    ],
    author: "Texas V.J. Construction",
    canonicalUrl: "https://texasvjconstruction.net/"
  },
  sections: {
    header: { businessName: "Texas V.J. Construction" },
    sectionB: {
      heroTitle: "Texas V.J. Construction",
      heroSubtitle: "Home Remodeling & Additions in Wilmington, DE",
      learnAboutText: "View Our Work",
      phoneNumber: "8328785222",
      phoneLabel: "(832) 878‑5222",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2151912551/photo/building-contractor-talking-to-clients-renovating-their-house.jpg?s=612x612&w=0&k=20&c=QhL8-C4dGz4ATIhLTaFYD_tKjHTLAKWZIBsuBW_n-ms=",
      cardData: [
        {
          title: "Home Additions",
          description: "Room expansions, sunrooms, 2nd-story additions."
        },
        {
          title: "General Remodeling",
          description: "Kitchens, bathrooms, basements & flooring."
        },
        {
          title: "Concrete & Carpentry",
          description: "Driveways, patios, framing, trim work."
        }
      ],
      description:
        "Texas V.J. Construction specializes in home renovations, additions, remodeling, and concrete & carpentry work throughout Wilmington, DE – delivering quality craftsmanship and exceptional service."
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive home improvement services tailored to your vision.",
      cards: [
        {
          title: "Room Additions",
          description: "Seamless additions to expand your living space.",
          imageSrc: "https://media.istockphoto.com/id/1772606342/photo/a-newly-constructed-home-improvement-project-in-process-of-framing-beams-for-wooden-house-in.jpg?s=612x612&w=0&k=20&c=WG_GXUgc5o9Ks2bG8JWHgun0aMV5pn9HfrUUOWSS9_0=",
          imageAlt: "Room Addition"
        },
        {
          title: "Kitchen & Bath Remodels",
          description: "Modern upgrades and full renovation services.",
          imageSrc: "https://media.istockphoto.com/id/2104606940/photo/interior-photographs-of-a-luxurious-residential-home-den-study-dining-room-kitchen-living.jpg?s=612x612&w=0&k=20&c=gOVkzFM2xszYCfUUbV5nrpyRXdpZyG69u4n7JUSg2mA=",
          imageAlt: "Kitchen Bath Remodel"
        },
        {
          title: "Concrete & Carpentry",
          description: "Framing, trim, driveways, patios, and walkways.",
          imageSrc: "https://media.istockphoto.com/id/1352308632/photo/construction-worker-cutting-a-plank-with-an-electric-saw.jpg?s=612x612&w=0&k=20&c=eZEHQk09A3sS79K93-eaSkEql0kbniLxzNklHzdYKJ8=",
          imageAlt: "Concrete Carpentry"
        }
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Basement Finishing",
        "Flooring Installation",
        "Custom Decks & Porches"
      ]
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://firebasestorage.googleapis.com/v0/b/clientesimages.appspot.com/o/Paginas%2F64cd2bbc3c7ba185a6d85fdb%2FiconAndLogo%2FTexas%20VJ%20Construction%20-%20WH.png?alt=media&token=b93cba12-235e-4172-a78e-1e6a2eecf497",
        alt: "Texas V.J. Construction Team"
      },
      aboutText: [
        "Texas V.J. Construction is led by Victor Joya, serving Wilmington, DE with expert home remodeling and additions.",
        "We’re dedicated to quality craftsmanship, transparent pricing, and client satisfaction."
      ]
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Texas V.J. Construction Logo",
      businessName: "Texas V.J. Construction",
      contact: {
        phone: "8328785222",
        phoneLabel: "(832) 878‑5222",
        email: "victorjoya19@gmail.com",
        website: "https://texasvjconstruction.net/",
        address: "36 Glenrich Ave, Wilmington, DE 19804"
      },
      socialMedia: {
        facebook: "https://www.facebook.com/texasvjconstructionservices/",
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null
      }
    },
    sectionF: {
      address: "36 Glenrich Ave, Wilmington, DE 19804",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3066.123456!2d-75.550123!3d39.717456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c627f8d3b4567b%3A0x89abcdef12345678!2s36%20Glenrich%20Ave%2C%20Wilmington%2C%20DE%2019804%2C%20USA!5e0!3m2!1sen!2sus!4v1718870000000!5m2!1sen!2sus"
    }
  }
};

export default config;
